import authentication from "./authentication";

import { combineReducers } from "redux";
export default combineReducers({
  authentication,
});
